import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useProject, Project } from './useData';
import { moduleConfig, getDetailSections } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Project>
      useData={useProject}
      config={{
        ...moduleConfig,
        getDetailSections,
      }}
    />
  );
};

export default Detail;

